import gql from "graphql-tag";

export const SAVE_PAVING_FOREMAN = gql`
  mutation savePavingForeman($where: SavePavingForeman!) {
    savePavingForeman(where: $where)
  }
`;